export const noMarginAccordianTheme = {
  components: {
    MuiAccordion: {
      defaultProps: {
        elevation: 0
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: 0,
          '&.Mui-expanded': {
            margin: 0
          }
        },
        content: {
          margin: 0,
          '&.Mui-expanded': {
            margin: 0
          }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    }
  }
};